import { render, staticRenderFns } from "./FilterItemInactive.vue?vue&type=template&id=51a820f4&scoped=true&"
import script from "./FilterItemInactive.vue?vue&type=script&lang=js&"
export * from "./FilterItemInactive.vue?vue&type=script&lang=js&"
import style0 from "./FilterItemInactive.vue?vue&type=style&index=0&id=51a820f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51a820f4",
  null
  
)

export default component.exports